<button class="column-container align-center full-view" (click)="nextStep()">
  @if (stepIndex() === step.FIRST) {
    <app-image-loading class="padding-left" src="assets/ic_guide_pic_zoom.svg" alt="點擊放大" i18n-alt
                       [targetWidth]="160"
                       [targetHeight]="155"
                       [clickable]="false"/>
    <div class="text center-container" i18n>點擊圖片上的&nbsp;
      <app-image-loading src="assets/ic_guide_goods_zoom.svg" alt="點擊放大" i18n-alt
                         [targetWidth]="25"
                         [targetHeight]="25"
                         [clickable]="false"/>
      ，可瀏覽大圖
    </div>
  } @else {
    <div class="fixed-container"
         [style.top.px]="topDistance()"
         [style.right.px]="rightDistance()">
      <app-image-loading alt="點擊切換圖片模式" i18n-alt
                         [src]="viewModel.mode() ? 'assets/ic_guide_picl.svg' : 'assets/ic_guide_detail_pics.svg'"
                         [targetWidth]="43"
                         [targetHeight]="43"
                         [clickable]="false"/>
      <app-bubble-content class="margin-right"
                          [content]="content"
                          [position]="arrowPosition.TOP_RIGHT"
                          [customArrowLeft]="89"/>
    </div>
  }
</button>
